// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-app-shared-AppFooter-__index-module___footer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app/shared/AppFooter/index.module.css
// module id = 571
// module chunks = 27